export enum UserStatus {
  NORMAL = "NORMAL",
  LEAVE = "LEAVE",
  SLEEP = "SLEEP",
  SUSPEND = "SUSPEND"
}
